export default __webpack_public_path__ + "static/media/contact_two.4daa3df5.jpg";